module.exports = __webpack_public_path__ + "img/empty-set.72bb09aa.svg";